/** Experimental RGBA32F field: static.xy + animated.xy for each authored layer.
 * Two guard texels permit bilinear reconstruction at framebuffer boundaries.
 * Never enabled without the explicit auroraWarp=half diagnostic switch.
 */
export class WarpField {
    gl;
    texture;
    framebuffer;
    width;
    height;
    static create(gl, width, height) {
        // Do not turn a diagnostic URL on a large/external display into a multi-GB
        // allocation. Above this budget use the direct renderer.
        if ((Math.ceil(width / 2) + 2) * (Math.ceil(height / 2) + 2) * 20 * 16 > 256 * 1024 * 1024)
            return null;
        if (!gl.getExtension("EXT_color_buffer_float"))
            return null;
        const texture = gl.createTexture();
        const framebuffer = gl.createFramebuffer();
        if (!texture || !framebuffer) {
            if (texture)
                gl.deleteTexture(texture);
            if (framebuffer)
                gl.deleteFramebuffer(framebuffer);
            return null;
        }
        const field = new WarpField(gl, texture, framebuffer, Math.ceil(width / 2) + 2, Math.ceil(height / 2) + 2);
        gl.bindTexture(gl.TEXTURE_2D_ARRAY, texture);
        const filter = gl.getExtension("OES_texture_float_linear") ? gl.LINEAR : gl.NEAREST;
        gl.texParameteri(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_MIN_FILTER, filter);
        gl.texParameteri(gl.TEXTURE_2D_ARRAY, gl.TEXTURE_MAG_FILTER, filter);
        gl.texStorage3D(gl.TEXTURE_2D_ARRAY, 1, gl.RGBA32F, field.width, field.height, 20);
        gl.bindFramebuffer(gl.FRAMEBUFFER, framebuffer);
        for (let i = 0; i < 4; i++)
            gl.framebufferTextureLayer(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0 + i, texture, 0, i);
        gl.drawBuffers([gl.COLOR_ATTACHMENT0, gl.COLOR_ATTACHMENT1, gl.COLOR_ATTACHMENT2, gl.COLOR_ATTACHMENT3]);
        const complete = gl.checkFramebufferStatus(gl.FRAMEBUFFER) === gl.FRAMEBUFFER_COMPLETE;
        gl.bindFramebuffer(gl.FRAMEBUFFER, null);
        if (!complete || gl.getError() !== gl.NO_ERROR) {
            field.destroy();
            return null;
        }
        return field;
    }
    constructor(gl, texture, framebuffer, width, height) {
        this.gl = gl;
        this.texture = texture;
        this.framebuffer = framebuffer;
        this.width = width;
        this.height = height;
    }
    destroy() {
        this.gl.deleteTexture(this.texture);
        this.gl.deleteFramebuffer(this.framebuffer);
    }
}
//# sourceMappingURL=warp-field.js.map